// extracted by mini-css-extract-plugin
export default {"container":"Table_container__YmQNy","txt_header_table":"Table_txt_header_table__VFcqw","txt_item_title":"Table_txt_item_title__KUTWN","table_row":"Table_table_row__cOkHV"};